import { useCallback, useContext } from 'react';
import { UserRightsContext } from 'src/contextProviders/UserRightsContext';
import { useSelector } from 'react-redux';
import { selectConfigurationsByAllKeywords, selectModules } from 'src/store/selectors/configurations';
import RoutingHelper from 'src/routes/routingHelper';
import { selectLocale } from 'src/store/selectors/translationSelectors';
import { useLocation } from 'react-router-dom';
function useRoutes() {
    const { checkUserRights } = useContext(UserRightsContext);
    const location = useLocation();
    const modules = useSelector(selectModules);
    const locale = useSelector(selectLocale);
    const configurations = useSelector(selectConfigurationsByAllKeywords);
    const isModuleEnabled = useCallback((type) => {
        const module = modules.find(({ Type = '' }) => Type === type);
        return module ? module.Enabled : false;
    }, [modules]);
    const isPathAllowed = useCallback((routePath) => {
        return RoutingHelper.isPathAllowed(routePath, checkUserRights, isModuleEnabled);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkUserRights, isModuleEnabled, configurations]);
    const getRoutes = useCallback((routes) => {
        return RoutingHelper.getRoutes(routes);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locale]);
    const getAllowedRoutes = useCallback((routes) => {
        return RoutingHelper.getAllowedRoutes(routes, isModuleEnabled, checkUserRights);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkUserRights, isModuleEnabled, locale, configurations]);
    const selectedRoute = RoutingHelper.getRouteByPath(location.pathname);
    return {
        isPathAllowed,
        getRoutes,
        getAllowedRoutes,
        selectedRoute
    };
}
export default useRoutes;
